/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef, useState } from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import PropTypes from 'prop-types';
import find from 'lodash/filter';
import head from 'lodash/head';
import useTranslation from 'next-translate/useTranslation';
import { connect } from 'react-redux';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import cx from 'clsx';
import Router from 'next/router';
import ElementLink, { ElementLinkPropTypes } from '../ElementLink';
import styles from './GlobalHeader.module.scss';
import { loadUserProfile } from '../../redux/modules/user';
import { clearPersonalizationCache } from '../../redux/modules/personalization';
import Asset from '../Asset';
import AssetPropTypes from '../Asset/AssetPropTypes';
import SearchInput from '../SearchInput';
import useLoginOrLogoutUrl from '../../utils/useLoginOrLogoutUrl';
import Link from 'next/link';
import { stubFalse } from 'lodash';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(false)
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width < 1024) {
        setIsMobile(true);
        setShowSearchIcon(true)
      }
      else {
        setIsMobile(false)
        setShowSearchIcon(false)
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return {
    isMobile,
    showSearchIcon
  }
}
export const GlobalHeaderPropTypes = {
  topNavigationLogo: PropTypes.shape(AssetPropTypes).isRequired,
  mainNavigation: PropTypes.arrayOf(PropTypes.shape(ElementLinkPropTypes)).isRequired,
  secondaryNavigation: PropTypes.arrayOf(PropTypes.shape(ElementLinkPropTypes)).isRequired
};

const mapStateToProps = (state) => {
  const {
    user: { firstName, lastInitial }
  } = state;
  return {
    firstName,
    lastInitial
  };
};

const mapDispatchToProps = {
  loadUser: loadUserProfile
};

function GlobalHeader({
  _id,
  // _contentTypeId,
  topNavigationLogo,
  mainNavigation,
  secondaryNavigation,
  firstName,
  lastInitial,
  loadUser
}) {
  const { t } = useTranslation();

  let signedIn = null
  firstName ? signedIn = true : signedIn = false
  const loginLogoutUrl = useLoginOrLogoutUrl(!signedIn);

  const menuRef = useRef(null);
  const signInButon = useRef(null);

  const handleClick = (value) => {
    if (typeof window === "undefined") return;
    value && localStorage.setItem("userSignedIN", "true")
    if (window.coveoua) {
      window.coveoua("init", process.env.ANALYTICS_API_KEY, process.env.ANALYTICS_ENDPOINT);
      coveoua("send", "pageview");
    }
    menuRef.current.click()
  };

  const handleLogoutClick = () => {
    if (typeof window === "undefined") return;
    localStorage.removeItem("userSignedIN")

    clearPersonalizationCache();
    menuRef.current.click()
  };

  const lastInteractionKeyboard = useRef(false);
  const dropdownToggleRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showUserName, setShowUserName] = useState(true)
  useEffect(() => {
    const localStorageValue = localStorage.getItem("userSignedIN")
    if (!firstName) {
      loadUser(localStorageValue, signInButon.current);
    }
    return function cleanup() { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstName]);

  // const homeLink = head(find(mainNavigation, (link) => link.as === '/home'));


  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Tab' || e.key.startsWith('Arrow')) {
        lastInteractionKeyboard.current = true;
      } else {
        lastInteractionKeyboard.current = false;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () =>
      window.removeEventListener('keydown', handleKeyDown);
  }, []);
  useEffect(() => {
    let observer;

    const setup = () => {
      const el = document.querySelector("#main-nav");
      const secele = document.querySelector("#sec-nav");

      if (!el || !secele) return;

      const update = () => {
        const isOpen =
          el.classList.contains("show") ||
          secele.classList.contains("show");

        document.body.style.overflowY = isOpen ? "hidden" : "visible";
      };

      update();

      observer = new MutationObserver(update);

      const config = {
        attributes: true,
        attributeFilter: ["class"],
      };

      observer.observe(el, config);
      observer.observe(secele, config);
    };

    const handleResize = () => {
      // cleanup old observer
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      // only setup for small screens
      if (window.innerWidth <= 1023) {
        setup();
      } else {
        document.body.style.overflowY = "visible"; // reset on desktop
      }
    };

    // run initially
    handleResize();

    // listen to resize
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      if (observer) observer.disconnect();
    };
  }, []);

  const handleDropdownFocus = () => {
    if (lastInteractionKeyboard.current) {
      setDropdownOpen(true);
    }
  };
  const handlehamburIcon = (val) => {
    if (typeof window !== 'undefined') {
      const hidemainNav = document.querySelector("#main-nav")
      const hidesecNav = document.querySelector("#sec-nav")
      if (!hidesecNav) return;
      if (val) {
        hidemainNav.style.zIndex = '9999';
        hidesecNav.style.zIndex = '999';
      }
      else {
        hidemainNav.style.zIndex = '999';
        hidesecNav.style.zIndex = '9999';
      }
    }

  }
  const handleDropdownToggle = (isOpen) => {
    setDropdownOpen(isOpen);
  };
  const { isMobile, showSearchIcon } = useIsMobile();

  return (
    <header data-testid="GlobalHeader" {...sidekick(_id, null, null, 'Global Header')}>
      <Navbar bg="white" expand="md" className={styles.navbar}>
        <ElementLink
          href="https://www.dropbox.com/"
          linkText="Homepage"
          className={styles.logo}
          isModal={false}
          trackingId="global_header_dropbox"
          download={false}>
          <Asset {...topNavigationLogo} isMobile={isMobile} imageWrapClassName={styles.logoImageWrap} isInlineSvg preload />
        </ElementLink>
        <Navbar.Collapse id="main-nav" className={styles.mainNavCollapse}>
          <Nav className={styles.mainNavBar} {...sidekick(_id, null, null, 'Navigation')}>

            {mainNavigation && mainNavigation.length
              ? mainNavigation.map((link, index) => {
                const linkClass = link.as === '/home' ? styles.mainNavLinkHome : null;
                const liClass = link.as === '/home' ? styles.mainNavLiHome : null;
                const uxaid = ({ variable }) => {
                  if (variable === 'https://help.dropbox.com/') {
                    return 'help';
                  } if (variable === 'https://www.dropboxforum.com/') {
                    return 'forum';
                  } if (variable === '/[slug]') {
                    return 'learn';
                  } if (variable === 'https://www.dropbox.com/support') {
                    return 'support';
                  }
                  return link.href; // default value, can be anything

                };

                return (
                  <div
                    className={cx(styles.mainNavItem, liClass)}
                    key={`main-nav-link56-${link._id || link.as || link.href || index}`}>
                    <ElementLink {...link} className={cx(styles.mainNavLink, styles.mainNavLinkTopLevel, linkClass)} trackingId={`global_main_nav_${uxaid({ variable: link.href })}`}>
                      {link.linkText}
                    </ElementLink>
                  </div>
                );
              })
              : null}
            {isMobile && !signedIn && <a onClick={() => handleClick("signedIn")} href={loginLogoutUrl} ref={signInButon} className={styles.btnSignin} data-testid="GlobalHeader-signin" data-uxa-log="global_header_login" data-uxa-interactions="click shown">
              {t('common:ctaTextLogIn')}
            </a>}
          </Nav>
        </Navbar.Collapse>
        <div data-testid="GlobalHeader-searchWrap" className={styles.searchBarWrap}>
          <SearchInput
            placeholder={t('common:headerSearchInputPlaceholder')}
            size="sm"
            actionCause="searchFromLink"
            dataHeader={"HeaderSearchBar"}
            showSearchIcon={showSearchIcon}
            parent="globalheader"
            signedIn={signedIn}
            setShowUserName={setShowUserName}


          />
        </div>
        {showUserName && <div data-testid="GlobalHeader-user-info" className={`${styles.signInWrap || ''} ${styles[signedIn] || ''}`}>
          {signedIn ? (
            <NavDropdown title={`${firstName && firstName.charAt(0).toUpperCase()}${lastInitial && lastInitial.charAt(0).toUpperCase()}`} bsPrefix={styles.userName} data-uxa-log={`global_header_${firstName}_${lastInitial}`}
              data-uxa-interactions="click shown"
              ref={dropdownToggleRef}
              show={dropdownOpen}
              onToggle={handleDropdownToggle}
              onFocus={handleDropdownFocus}
              className={styles.navListNew}>


              <NavDropdown.Item as={ElementLink} href="/profile" className={styles.navList} linkText={t('common:ctaTextProfile')} trackingId="global_header_profile">
                {t('common:ctaTextProfile')}
              </NavDropdown.Item>
              <NavDropdown.Item href={loginLogoutUrl} className={styles.navList} onClick={() => handleLogoutClick()} data-uxa-log="global_header_sign_out" data-uxa-interactions="click shown">{t('common:ctaTextLogout')}</NavDropdown.Item>
            </NavDropdown>
          ) : (
            !isMobile && (<a onClick={() => handleClick("signedIn")} href={loginLogoutUrl} ref={signInButon} className={styles.btnSignin} data-testid="GlobalHeader-signin" data-uxa-log="global_header_login" data-uxa-interactions="click shown">
              {t('common:ctaTextLogIn')}
            </a>)
          )}
        </div>
        }

        <Navbar.Toggle aria-controls="main-nav" className={styles.mainNavToggle} ref={menuRef} onClick={() => handlehamburIcon("mainnav")}>
          <Asset
            url="/images/assets/listview.svg"
            title="Open Mobile Nav"
            isInlineSvg
            imageWrapClassName="main-nav-toggle-open"
          />
          <Asset
            url="/images/assets/cross.svg"
            title="Close Mobile Nav"
            isInlineSvg
            imageWrapClassName="main-nav-toggle-close"
          />
        </Navbar.Toggle>
      </Navbar>
      <Navbar expand="md" className={styles.secnavbar}>
        <div className={styles.secondaryMenu}>
          <div className={styles.homepage}><a href="/">{t('common:learnText')}</a></div>
          {secondaryNavigation && secondaryNavigation.length ? (
            <div
              className={styles.secondaryNavbarWrap}
              {...sidekick(_id, 'secondaryNavigation', null, 'Secondary Navigation')}>
              <nav className={styles.secondaryNavbar}>
                <ul className={styles.secondaryNavbarNav}>
                  {secondaryNavigation.map((link) => (
                    <li
                      className={`secondary-nav-item ${styles.secondaryNavItem}`}
                      key={`secondary-nav-link123-${link._id || link.as || link.href}`}>
                      <ElementLink {...link} className={styles.secondaryNavLink} trackingId={`global_secondary_nav_${link.href}`}>
                        {link.linkText}
                      </ElementLink>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          ) : null}
          <Navbar.Collapse id="sec-nav" className={styles.secNavCollapse} >
            <Nav className={styles.mainNavBar} {...sidekick(_id, null, null, 'Navigation')}>
              {secondaryNavigation && secondaryNavigation.length
                ? secondaryNavigation.map((link) => (
                  <div
                    className={styles.secondaryNavItemMain}
                    key={`sec-nav-link12-${link._id || link.as || link.href}`}
                    role="button"
                    tabIndex="0"
                    onClick={() => handleClick()}
                    onKeyDown={() => handleClick()}>
                    <ElementLink {...link} className={styles.mainNavLink}>
                      {link.linkText}
                    </ElementLink>
                  </div>
                ))
                : null}

            </Nav>
          </Navbar.Collapse>

          <Navbar.Toggle aria-controls="sec-nav" className={styles.secNavToggle} ref={menuRef} onClick={() => handlehamburIcon()}>
            <Asset
              url="/images/assets/chevronDown.svg"
              title="Open Mobile Nav"
              isInlineSvg
              imageWrapClassName="sec-nav-toggle-open"
            />
            <Asset
              url="/images/assets/chevronUp.svg"
              title="Close Mobile Nav"
              isInlineSvg
              imageWrapClassName="sec-nav-toggle-close"
            />
          </Navbar.Toggle>
        </div>
      </Navbar>
    </header>
  );
}

GlobalHeader.propTypes = {
  ...GlobalHeaderPropTypes,
  firstName: PropTypes.string,
  lastInitial: PropTypes.string,
  loadUser: PropTypes.func.isRequired
};

GlobalHeader.defaultProps = {
  firstName: null,
  lastInitial: 'null'
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalHeader);